const TYPE = {
  AMBOS: 'Ambos',
  PRESCRIPTOR: 'Prescriptor',
  REALIZADOR: 'Realizador',
};

export { TYPE };
